import React, { useState } from 'react';
import { trackShipments } from '../../../services/fedexApi';
import TrackingResult from './TrackingResult';

const FedexTracking = () => {
  const [trackingNumbers, setTrackingNumbers] = useState('');
  const [trackingInfo, setTrackingInfo] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleTrack = async () => {
    if (!trackingNumbers) {
      setError('Veuillez saisir au moins un numéro de suivi.');
      return;
    }

    setLoading(true);
    setError(null);
    setTrackingInfo(null);

    try {
      const numbers = trackingNumbers.split(/\s*[,\n\s]+\s*/).filter(Boolean);
      const response = await trackShipments(numbers);
      setTrackingInfo(response);
    } catch (err) {
      const errorMessage = err.response?.data?.details?.errors?.[0]?.message || err.response?.data?.message || 'Erreur lors du suivi des expéditions. Veuillez vérifier les numéros et réessayer.';
      setError(errorMessage);
    }

    setLoading(false);
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4 leading-tight sm:whitespace-nowrap">Suivi d&apos;expédition FedEx</h1>
      
      <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md">
        <div className="mt-2 flex flex-col sm:flex-row sm:items-end gap-3">
          <div className="w-full">
            <label htmlFor="trackingNumbers" className="block text-sm font-medium text-gray-700">
              Numéro de suivi
            </label>
            <input
              type="text"
              id="trackingNumbers"
              className="w-full mt-1 p-2 border border-gray-300 rounded-md"
              value={trackingNumbers}
              onChange={(e) => setTrackingNumbers(e.target.value)}
              placeholder="XXXXXXXXXXXX"
              inputMode="text"
              autoComplete="off"
              aria-label="Numéro de suivi FedEx"
            />
          </div>

          <button
            onClick={handleTrack}
            disabled={loading}
            className="w-full sm:w-auto bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 disabled:bg-gray-400 whitespace-nowrap inline-flex justify-center"
            aria-label="Lancer le suivi"
            title="Suivre"
          >
            {loading ? 'Recherche en cours...' : 'Suivre'}
          </button>
        </div>
      </div>

      {error && (
        <div className="mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
          <strong className="font-bold">Erreur :</strong>
          <span className="block sm:inline"> {error}</span>
        </div>
      )}

      {trackingInfo && <TrackingResult trackingInfo={trackingInfo} />}
    </div>
  );
};

export default FedexTracking;
